import React from "react";

export default class ErrorBoundary extends React.Component {
  state = { error: null };

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    // eslint-disable-next-line no-console
    console.error("App crashed:", error, info);
  }

  render() {
    if (this.state.error) {
      return (
        <div className="min-h-screen flex items-center justify-center bg-background px-6">
          <div className="max-w-lg w-full bg-white border border-brand-line rounded-sm p-8">
            <div className="text-[10px] uppercase tracking-[0.3em] text-brand-terracotta mb-3">Something went wrong</div>
            <h1 className="font-serif text-3xl text-brand-ink mb-3">We hit a snag</h1>
            <p className="text-sm text-brand-muted mb-5">
              The app encountered an unexpected error. Please reload — your data is safe.
            </p>
            <pre className="text-xs font-mono bg-secondary p-3 rounded-sm overflow-x-auto max-h-40 text-brand-terracotta">
              {String(this.state.error?.message || this.state.error)}
            </pre>
            <button
              onClick={() => window.location.assign("/")}
              className="mt-5 px-4 py-2 rounded-sm bg-brand-forest text-white text-xs uppercase tracking-[0.15em]"
            >
              Reload App
            </button>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}
